import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { FilterModel } from 'src/Models/filterModel';
import { RMDScheduleLogHistoryModel } from 'src/Models/RMDScheduleLogHistoryModel';
import { RMDUpdatesModel } from 'src/Models/RMDUpdatesModel';
import { RmdupdatesService } from 'src/Services/rmdupdates.service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-rmd-updates',
  templateUrl: './rmd-updates.component.html',
  styleUrls: ['./rmd-updates.component.css']
})
export class RMDUpdatesComponent implements OnInit {

  filterModel = new FilterModel();
  currentPage: number = 1;
  totalRecordCount: number = -1;

  rmdUpdatesModel: RMDUpdatesModel[];
  rmdUpdatesExportModel: RMDUpdatesModel[];
  carrier: RMDUpdatesModel;

  tokenKey: string = '';
  SelectedTool: string;

  isAscending: boolean = false
  upDownBussinessNameCSS: string = '';
  upDownPrevious_dba_namesCSS: string = '';
  upDownOther_dba_namesCSS: string = '';
  upDownForeign_voice_providerCSS: string = '';
  upDownImplementationCSS: string = '';
  upDownSys_updated_onCSS: string = '';
  upDownUpdateCountCSS: string = '';
  upDownFrn_strCSS: string = '';


  isloading: boolean;
  iscarrierloading: boolean;
  dropdownSettingsActionName = {};
  dropdownListActionName = [];
  selecteddropdownListActionName = [];

  dropdownSettingsProduct = {};
  dropdownListProduct = [];
  selecteddropdownListProduct = [];
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  lastModifiedDetails = '';
  ishistoryloading = false;
  historyModel: RMDScheduleLogHistoryModel[];
  totalHistoryCount = -1;

  constructor(private readonly rmdUpdatesService: RmdupdatesService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('RMD Updates');
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'Sys_updated_on DESC';
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.movetotop();
    this.GetRMDUpdatesFilter();
  }

  GetRMDUpdatesFilter() {
    this.isloading = true;
    this.rmdUpdatesModel = [];
    this.filterModel.IsExport = false;
    this.rmdUpdatesService.GetUpdatesFilterByPageV2(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          this.rmdUpdatesModel = data['updates'];
          if (this.rmdUpdatesModel != null) {
            if (this.rmdUpdatesModel.length > 0) {
              this.totalRecordCount = this.rmdUpdatesModel[0].totalRecordCount;
              this.lastModifiedDetails = 'Last updated on ' + this.rmdUpdatesModel[0].lastModifiedDate;
            }
            else {
              this.totalRecordCount = 0;
            }
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  keywordFilters(event) {
    this.filterModel.pageNumber = '1';
    if (event.target.value != "" && event.target.value != null)
      this.filterModel.keywordFilter = event.target.value;
    else
      this.filterModel.keywordFilter = '';

    this.currentPage = 1;
    this.GetRMDUpdatesFilter();
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.GetRMDUpdatesFilter();
  }

  cleanCssClass() {
    this.upDownBussinessNameCSS = '';
    this.upDownPrevious_dba_namesCSS = '';
    this.upDownOther_dba_namesCSS = '';
    this.upDownForeign_voice_providerCSS = '';
    this.upDownImplementationCSS = '';
    this.upDownSys_updated_onCSS = '';
    this.upDownUpdateCountCSS = '';
    this.upDownFrn_strCSS = '';
  }

  sort(sortBy: any) {
    this.cleanCssClass();

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "Business_name") {
        this.upDownBussinessNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Previous_dba_names") {
        this.upDownPrevious_dba_namesCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Other_dba_names") {
        this.upDownOther_dba_namesCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Foreign_voice_provider") {
        this.upDownForeign_voice_providerCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Implementation") {
        this.upDownImplementationCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Sys_updated_on") {
        this.upDownSys_updated_onCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "UpdateCount") {
        this.upDownUpdateCountCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "Frn_str") {
        this.upDownFrn_strCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "Business_name") {
        this.upDownBussinessNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Previous_dba_names") {
        this.upDownPrevious_dba_namesCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Other_dba_names") {
        this.upDownOther_dba_namesCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Foreign_voice_provider") {
        this.upDownForeign_voice_providerCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Implementation") {
        this.upDownImplementationCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Sys_updated_on") {
        this.upDownSys_updated_onCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "UpdateCount") {
        this.upDownUpdateCountCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "Frn_str") {
        this.upDownFrn_strCSS = 'fa fa-arrow-up';
      }
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetRMDUpdatesFilter();
  }

  ActiveInactiveUpdates(updateId: any, isactive: any) {
    this.blockDocument();
    this.rmdUpdatesService.ActiveInactiveRMDUpdates(this.tokenKey, updateId, isactive)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (isactive) {
            this.showMessage('Activated successfully', 'Active', 'success');
          }
          else {
            this.showMessage('Inactivated successfully', 'Inactive', 'success');
          }
          this.GetRMDUpdatesFilter();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }
        this.unblockDocument();
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  getCarrierUpdateHistory(id: number) {
    this.ishistoryloading = true;
    this.rmdUpdatesService.GetUpdateHistoryByCarrierID(this.tokenKey, id).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.historyModel = data["updates"];
        }
        else {
          this.showMessage('There is an issue while fetching data. Please try again.', 'Error', 'error');
        }
        this.ishistoryloading = false;
      },
      error => {
        this.ishistoryloading = false;
      },
    );
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }
  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  GetRMDUpdateById(carrierId) {
    this.carrier = undefined;
    this.iscarrierloading = true;
    this.rmdUpdatesService.GetRMDUpdatesFindByCarrierID(this.tokenKey, carrierId).subscribe(
      data => {
        this.iscarrierloading = false;
        if (data != null) {
          this.carrier = data['updates'];
        }
      },
      error => {
        this.iscarrierloading = false;
        console.log(error);
      }
    );
  }

  ExportRMDUpdate() {
    this.isloading = true;
    this.rmdUpdatesExportModel = [];
    this.filterModel.IsExport = true;
    this.rmdUpdatesService.GetUpdatesFilterByPageV2(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.rmdUpdatesExportModel = data['updates'];
          if (this.rmdUpdatesExportModel != null) {
            if (this.rmdUpdatesExportModel.length > 0) {
              setTimeout(() => {
                this.DownloadRMDUpdate();
                this.isloading = false;
              }, 2000);
            }
            else {
              this.isloading = false;
              this.toastr.error("No record found", "Error");
            }
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadRMDUpdate() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportRMDProviderUpdates';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportRMDProviderUpdates.xls");
  }

}